import React, { useCallback } from 'react'
import { FlatList, StyleSheet } from 'react-native'

import { Control } from 'react-hook-form'

import { IOcField } from '../../utils/types'
import FormController from './FormController'

interface Props {
  ocFields: IOcField[]
  control: Control
}

const Form: React.FC<Props> = (props) => {
  const { ocFields, control } = props

  const renderItem = useCallback(({ item }) => {
    return <FormController control={control} ocField={item} />
  }, [])

  return (
    <>
      <FlatList
        data={ocFields}
        contentContainerStyle={styles.container}
        // estimatedItemSize={30}
        renderItem={renderItem}
        keyExtractor={(item) => item?.code}
      />
    </>
  )
}

export default Form

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
})
